export default __webpack_public_path__ + "static/media/home-desktop.1de4b53f.jpg";